import { DEMO_PDF_MAX_BODY_BYTES } from "./demoConstants.js";

// 上限超過のままだとnginxが413を返すため、超える場合は空で送ってサーバー側の422（invalid_form）に任せる。
// フォームPOSTはURLエンコードで膨らむので、実際に送るボディと同じ形でバイト数を見る
export const isDemoPdfBodyWithinLimit = (csrfToken, demoFormData) =>
  new URLSearchParams({
    authenticity_token: csrfToken || "",
    demo_form_data: demoFormData || "",
  }).toString().length <= DEMO_PDF_MAX_BODY_BYTES;
